import { api } from '@/apis';
import { log } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => {
      if (code) {
        log('Delete', 'Location', { code });

        return api.delete(`groups/${code}`).json();
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['groups'] }),
  });
}
